import { Link } from 'react-router-dom';
import { Smartphone, Monitor, Home, ExternalLink } from 'lucide-react';

const DISCORD_LINK = 'https://discord.gg/mediocretoons';

export default function VpnPage() {
    return (
        <main className="min-h-screen bg-black flex items-center justify-center px-6 pt-28 pb-24">
            <div className="max-w-xl mx-auto text-center">
                <div className="mb-12">
                    <div className="flex justify-center mb-8">
                        <div className="relative w-44 h-44 overflow-hidden rounded-3xl shadow-2xl shadow-orange-900/20 ring-4 ring-orange-500/10">
                            <img
                                src="/warp.webp"
                                alt="Cloudflare WARP"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>
                    <h1 className="text-4xl font-black text-white italic uppercase mb-4 leading-tight">
                        Sem acesso ao conteúdo?
                    </h1>
                    <p className="text-white/40 font-bold uppercase tracking-widest text-sm leading-relaxed max-w-lg mx-auto">
                        Três mil demônios podem estar bloqueando sua conexão. Use o WARP da Cloudflare para atravessar o abismo e ler em paz.
                    </p>
                </div>

                <div className="grid gap-4 mb-10 text-left">
                    <a
                        href="https://play.google.com/store/apps/details?id=com.cloudflare.onedotonedotonedotone&hl=pt_BR"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group flex items-center gap-5 p-5 bg-neutral-900 border border-white/5 hover:border-orange-500/30 rounded-2xl transition-all duration-300"
                    >
                        <div className="h-12 w-12 rounded-xl bg-orange-500/10 flex items-center justify-center text-orange-500 group-hover:bg-orange-500 group-hover:text-white transition-all"><Smartphone size={24} /></div>
                        <div className="flex-1">
                            <span className="block text-white font-black uppercase italic text-sm mb-0.5">Baixar para Android</span>
                            <span className="block text-white/30 text-xs font-bold uppercase tracking-widest">Google Play Store</span>
                        </div>
                        <ExternalLink size={18} className="text-white/20 group-hover:text-orange-500 transition-colors" />
                    </a>

                    <a
                        href="https://apps.apple.com/br/app/1-1-1-1-faster-internet/id1423538627"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group flex items-center gap-5 p-5 bg-neutral-900 border border-white/5 hover:border-orange-500/30 rounded-2xl transition-all duration-300"
                    >
                        <div className="h-12 w-12 rounded-xl bg-orange-500/10 flex items-center justify-center text-orange-500 group-hover:bg-orange-500 group-hover:text-white transition-all"><Smartphone size={24} /></div>
                        <div className="flex-1">
                            <span className="block text-white font-black uppercase italic text-sm mb-0.5">Baixar para iOS</span>
                            <span className="block text-white/30 text-xs font-bold uppercase tracking-widest">Apple App Store</span>
                        </div>
                        <ExternalLink size={18} className="text-white/20 group-hover:text-orange-500 transition-colors" />
                    </a>

                    <a
                        href="https://one.one.one.one/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group flex items-center gap-5 p-5 bg-neutral-900 border border-white/5 hover:border-orange-500/30 rounded-2xl transition-all duration-300"
                    >
                        <div className="h-12 w-12 rounded-xl bg-orange-500/10 flex items-center justify-center text-orange-500 group-hover:bg-orange-500 group-hover:text-white transition-all"><Monitor size={24} /></div>
                        <div className="flex-1">
                            <span className="block text-white font-black uppercase italic text-sm mb-0.5">Baixar para Computador</span>
                            <span className="block text-white/30 text-xs font-bold uppercase tracking-widest">Windows & MacOS</span>
                        </div>
                        <ExternalLink size={18} className="text-white/20 group-hover:text-orange-500 transition-colors" />
                    </a>
                </div>

                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <a
                        href={DISCORD_LINK}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-center gap-3 px-8 py-5 bg-[#5865F2] hover:bg-[#4752C4] text-white font-black rounded-2xl transition-all uppercase italic shadow-xl shadow-blue-900/20"
                    >
                        <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor"><path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C2.451 6.018 1.99 7.765 1.99 9.54c0 5.089 3.158 9.417 7.18 11.174a.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028c4.022-1.757 7.18-6.085 7.18-11.174 0-1.775-.46-3.522-1.648-5.142a.066.066 0 0 0-.031-.03z" /></svg>
                        Entrar no Discord
                    </a>
                    <Link
                        to="/"
                        className="flex items-center justify-center gap-3 px-8 py-5 bg-neutral-900 hover:bg-neutral-800 text-white font-black rounded-2xl transition-all uppercase italic border border-white/5"
                    >
                        <Home size={22} />
                        Início
                    </Link>
                </div>
            </div>
        </main>
    );
}
